function getCookies() {
  const cookies = {};

  for (const cookie of document.cookie.split(';')) {
    const [key, value] = cookie.split('=');

    cookies[key] = value;
  }

  return cookies
}

function getUTMValuesFromURL() {
  const utmValues = {};
  const queryParameters = new URLSearchParams(window.location.search);

  for (const [key, value] of queryParameters) {
    if (key.startsWith('utm_')) {
      utmValues[key] = value;
    }
  }

  return utmValues;
}

function convertCookieToUTMValues(cookie) {
  const cookieValue = decodeURIComponent(cookie);
  const utmValues = {};
  const values = cookieValue.split('&');

  for (const pair of values) {
    const [key, value] = pair.split('=');

    utmValues[key] = value;
  }

  return utmValues;
}

function getUTMValues(cookies) {
  const currentUTMValues = getUTMValuesFromURL();
  let utmValues = {};
  let utmCookieValue = cookies['_shopify_sa_p'];

  if (utmCookieValue) {
    utmValues = convertCookieToUTMValues(utmCookieValue);
  }

  for (const [key, value] of Object.entries(currentUTMValues)) {
    utmValues[key] = value;
  }

  return utmValues;
}

function setFirstPageCookie(value) {
  document.cookie = 'ep_first_page='
      + value
      + '; Path=/; Expires='
      + new Date((new Date).getTime() + 1000 * 60 * 60 * 24).toUTCString()
      + '; SameSite=Lax; Domain=.expertphotography.com; Secure;';
}

function getFirstPageVisited(cookies) {
  let firstPage = window.location.origin + window.location.pathname;
  
  if (cookies.ep_first_page) {
    firstPage = cookies.ep_first_page;
  } else {
    setFirstPageCookie(firstPage);
  }

  return firstPage;
}

function setFirstVisit() {
  document.cookie = 'ep_first_visit='
      + Date.now()
      + '; Path=/; Expires='
      + new Date((new Date).getTime() + 1000 * 60 * 60 * 24).toUTCString()
      + '; SameSite=Lax; Domain=.expertphotography.com; Secure;';
}

function getTimeOnSite(cookies) {
  let startTime = cookies.ep_first_visit;
  let time = 1;

  if (startTime) {
    time = Date.now() - parseInt(startTime, 10);
  } else {
    setFirstVisit();
  }
    
  return Math.ceil(time / 1000);
}

function getPageHistory() {
  const pageHistory = localStorage.getItem('ep_page_history');
  let history = [window.location.origin + window.location.pathname];

  if (pageHistory) {
    try {
      const storedHistory = JSON.parse(pageHistory);

      history = storedHistory;
    } catch (error) {
      console.error(error);
    }
  }

  return history;
}

function addCurrentPageToHistory() {
  const history = new Set(getPageHistory());

  history.add(window.location.origin + window.location.pathname);

  localStorage.setItem('ep_page_history', JSON.stringify(Array.from(history)));
}

function dateToRFC3339Extended(date) {
  function pad(n) {
    return n < 10 ? ('0' + n) : n;
  }

  function timezoneOffset(offset) {
      var sign;

      if (offset === 0) {
        return 'Z';
      }

      sign = (offset > 0) ? '-' : '+';
      offset = Math.abs(offset);

      return sign + pad(Math.floor(offset / 60)) + ":" + pad(offset % 60);
  }

  return date.toISOString().replace('Z', timezoneOffset(date.getTimezoneOffset()));
}

function updateFormFields() {
  const cookies = getCookies();
  const utmValues = getUTMValues(cookies);
  const deviceType = navigator.userAgent.match(/Android|iPhone|iPad|iPod|BlackBerry|Opera Mini|IEMobile|WPDesktop/i) ? 'mobile' : 'desktop';
  const pageHistory = getPageHistory();
  const fieldValues = [
    deviceType, utmValues.utm_adgroup, utmValues.utm_campaign, utmValues.utm_content, utmValues.utm_medium, utmValues.utm_referurl,
    utmValues.utm_source, utmValues.utm_term, utmValues.utm_ip, getFirstPageVisited(cookies), window.location.origin + window.location.pathname,
    getTimeOnSite(cookies), pageHistory.length, dateToRFC3339Extended(new Date())
  ];
  const fieldSelectors = [
    '[name="custom_fields[track_site_mobile_desktop]"]',
    '[name="custom_fields[track_utm_adgroup]"]',
    '[name="custom_fields[track_utm_gacampaign]"]',
    '[name="custom_fields[track_utm_gacontent]"]',
    '[name="custom_fields[track_utm_gamedium]"]',
    '[name="custom_fields[track_utm_gareferurl]"]',
    '[name="custom_fields[track_utm_gasource]"]',
    '[name="custom_fields[track_utm_gaterm]"]',
    '[name="custom_fields[track_utm_ip]"]',
    '[name="custom_fields[track_site_first_page]"]',
    '[name="custom_fields[track_site_last_page]"]',
    '[name="custom_fields[track_site_time_on_site]"]',
    '[name="custom_fields[track_site_number_of_pages]"]',
    '[name="custom_fields[activity_last_funnel_date]"]'
  ];

  for (let i = 0; i <= fieldSelectors.length; i++) {
    if (fieldValues[i] != undefined) {
      const fields = document.querySelectorAll(fieldSelectors[i]);

      for (const field of fields) {
        field.value = fieldValues[i];
      } 
    }
  }
}

addCurrentPageToHistory();
document.addEventListener('DOMContentLoaded', updateFormFields);